var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1676(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1676",
    "data-name": "Groupe 1676",
    transform: "translate(-8588 -1599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1283",
    "data-name": "Rectangle 1283",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(8588 1599)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_setting-2",
    "data-name": "vuesax/linear/setting-2",
    transform: "translate(8318.202 1445.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.149,4.574A4.574,4.574,0,1,1,4.574,0,4.574,4.574,0,0,1,9.149,4.574Z",
    transform: "translate(13.723 13.723)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,15.734V13.051a2.906,2.906,0,0,1,2.9-2.9c2.76,0,3.888-1.952,2.5-4.346A2.9,2.9,0,0,1,6.465,1.859L9.1.349a2.545,2.545,0,0,1,3.477.915l.168.29c1.372,2.394,3.629,2.394,5.017,0l.168-.29A2.545,2.545,0,0,1,21.408.349l2.638,1.51a2.9,2.9,0,0,1,1.067,3.949c-1.388,2.394-.259,4.346,2.5,4.346a2.906,2.906,0,0,1,2.9,2.9v2.684a2.906,2.906,0,0,1-2.9,2.9c-2.76,0-3.888,1.952-2.5,4.346a2.892,2.892,0,0,1-1.067,3.949l-2.638,1.51a2.545,2.545,0,0,1-3.477-.915l-.168-.29c-1.372-2.394-3.629-2.394-5.017,0l-.168.29a2.545,2.545,0,0,1-3.477.915l-2.638-1.51A2.9,2.9,0,0,1,5.4,22.977c1.388-2.394.259-4.346-2.5-4.346A2.906,2.906,0,0,1,0,15.734Z",
    transform: "translate(3.05 3.905)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H36.6V36.6H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1676);
export default __webpack_public_path__ + "static/media/Groupe-1676.225703484b136b98e8661cbf0d13c0ee.svg";
export { ForwardRef as ReactComponent };